/* CSV export helpers — client-side. */

function escapeCell(value) {
    if (value === null || value === undefined) return "";
    const s = String(value);
    if (s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
        return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
}

export function downloadCsv(filename, columns, rows) {
    const header = columns.map((c) => escapeCell(c.label)).join(",");
    const body = rows
        .map((row) =>
            columns
                .map((c) => {
                    const val = typeof c.value === "function" ? c.value(row) : row[c.key];
                    return escapeCell(val);
                })
                .join(","),
        )
        .join("\n");
    const csv = `${header}\n${body}\n`;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
